(function () {
	const e = document.getElementById('browser-check');
	e.style.display = '';
	e.classList.remove('display-none');
})();
